import { Button } from "@/components/ui/button"
import { useNapForm } from "../NapFormContext"
import { LookupItem } from "@/types/activity"
import { BedDouble } from "lucide-react"

interface LocationStepProps {
  locations: LookupItem[]
  childName?: string
  onNext: () => void
  onPrev?: () => void
}

export function LocationStep({ locations, childName, onNext, onPrev }: LocationStepProps) {
  // Access form through context
  const form = useNapForm();
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-center">
        Where did {childName || 'your baby'} sleep?
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto">
        {locations.map((location) => (
          <Button
            key={location.id}
            type="button"
            variant={form.watch("location_id") === location.id ? "default" : "outline"}
            className="w-full py-3 px-4 h-auto text-left justify-start hover:bg-accent/50 whitespace-normal"
            onClick={() => {
              form.setValue("location_id", location.id)
              form.clearErrors("location_id")
              onNext()
            }}
          >
            <BedDouble className="mr-2 h-4 w-4 shrink-0" />
            <span className="text-sm line-clamp-2">{location.name || location.description || location.id}</span>
          </Button>
        ))}
      </div>
      
      {form.formState.errors.location_id && (
        <p className="text-sm text-destructive">
          {form.formState.errors.location_id.message}
        </p>
      )}
      
      <div className="flex justify-between pt-4">
        {onPrev && (
          <Button 
            type="button" 
            variant="outline" 
            onClick={onPrev}
            className="border-white/10 text-gray-300 hover:bg-white/5"
          >
            Back
          </Button>
        )}
        
        <Button
          type="button"
          onClick={() => {
            // Only proceed if a location is selected
            if (form.getValues("location_id")) {
              onNext();
            } else {
              form.setError("location_id", {
                type: "manual",
                message: "Please select a location"
              });
            }
          }}
          className="ml-auto bg-purple-500 hover:bg-purple-600 text-white"
        >
          Skip
        </Button>
      </div>
    </div>
  )
}